import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { XMarkVariants } from "../XMark.types";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(["XMark", "symbol", "container"]);
const baseStyle = {};
const variants = {
    deepBlue: definePartsStyle({
        symbol: {
            fill: "semantic.brand.primary",
        },
    }),
    ultraGreen: definePartsStyle({
        symbol: {
            fill: "semantic.brand.secondary",
        },
    }),
    boldyBlue: definePartsStyle({
        symbol: {
            fill: "semantic.brand.tertiary",
        },
    }),
    veryYellow: definePartsStyle({
        symbol: {
            fill: "semantic.brand.quaternary",
        },
    }),
    confidentlyCoral: definePartsStyle({
        symbol: {
            fill: "semantic.brand.quinary",
        },
    }),
    white: definePartsStyle({
        symbol: {
            fill: "semantic.icon.inverse",
        },
    }),
};
const XMarkTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {
        variant: XMarkVariants.DEEP_BLUE,
    },
});
export default XMarkTheme;
//# sourceMappingURL=XMark.default.js.map